
// Default keyword가 없으면 이름을 가지는 내보내기 방식
class $d43825b7d483c6e2$export$1e8bdf0a3b60829f {
    // 객체 구조로 인자를 받을 수 있도록 함
    // 'constructor': A special method for class
    // constructor: A special method for creating and initializing objects created by a class. In a class, there can be only one constructor method.
    // static methods: These are methods that belong to the class itself, not to any particular object instance of that class. You call them on the class itself rather than an instance of the class.
    // getters and setters: Special methods to define custom logic when accessing and setting properties on objects. They are prefixed with get and set, respectively.
    // prototype methods: Any method you define on a class, which is not static, is a prototype method. These methods are available on all instances of the class.
    constructor(payload = {}){
        // 객체 구조 분해 할당(객체의 속성 꺼내기 및 기본값 할당)
        // 하기 내용은 payload 객체의 속성을 꺼내어 사용하겠다는 의미
        // payload 객체가 없을 경우 기본값을 사용하겠다는 의미
        const { tagName: tagName = "div", state: state = {}, props: props = {} } = payload;
        this.test = document.createElement("div");
        this.el = document.createElement(tagName);
        this.state = state;
        this.props = props;
        // 인스턴스 생성 시 render 메소드를 최초 실행
        this.render();
    }
    // 'render': A custom method
    render() {
        console.log("This default and it is overrided by child class.");
    }
}
// Router Function
function $d43825b7d483c6e2$var$routeRender(routes) {
    // alert("routes: " + JSON.stringify(routes[0].component));
    // console.dir("routes: "+JSON.stringify(routes[0].component));
    // const jsonTest = JSON.stringify(class Home extends (0, _coreJs.CoreComponent) {
    //   render() {
    //     const headline = new (0, _headlineDefault.default)().el;
    //     const search = new (0, _searchJsDefault.default)().el;
    //     const movieList = new (0, _movieListJsDefault.default)().el;
    //     const movieListMore = new (0, _movieListMoreJsDefault.default)().el;
    //     this.el.classList.add("container");
    //     this.el.append(headline, search, movieList, movieListMore);
    //   }
    // });
    // alert("routes: "+JSON.stringify(routes));
    // alert("location: "+location)
    // const checker = document.createElement('div');
    // checker.textContent =
    //   'Checker: ' +
    //   'location.hash: ' +
    //   location.hash;
    // document.body.appendChild(checker);
    if (!location.hash) // alert('No hash')
    // history.replaceState(null, '', '#/');
    history.replaceState(null, "", "/#/404");
    const routerView = document.querySelector("router-view");
    // http://.../#/about
    // #/about?name=abc (해쉬 라우터)
    const [hash, queryString = ""] = location.hash.split("?");
    // console.log(location.hash);
    // 1. history에 상태값 저장 
    // a=1234&b=5678
    // 위의 Query String을 { a: 1234, b: 5678 }과 같은 객체로 변환
    const query = queryString.split("&").reduce((acc, cur)=>{
        const [key, value] = cur.split("=");
        acc[key] = value;
        return acc;
    }, {});
    // 콘솔 창에서 history 객체의 상태를 확인하면 상태가 추가된 것을 확인할 수 있음(history 입력 후 엔터)
    // alert('query: ' + JSON.stringify(query))
    history.replaceState(query, "");
    // history.state만 변경하고 실제로 URL을 변경하거자 하진 않음
    // a는 a 값이고 b는 b 값이 됨
    // id가 있을 경우 id값을 가져옴
    // 2. 라우팅
    // find() 메소드는 주어진 판별 함수를 만족하는 첫 번째 요소의 값을 반환합니다. 그런 요소가 없다면 undefined를 반환합니다.
    // alert('hash: ' + hash)
    const currentRoute = routes.find((route)=>{
        return new RegExp(`^${route.path}(?![^#])`).test(hash);
    });
    if (routerView) {
        routerView.innerHTML = "";
        // alert("currentRoute: " + currentRoute)
        if (currentRoute && currentRoute.component) routerView.append(new currentRoute.component().el);
    }
    // 페이지의 스크롤 위치 초기화(최상단 배치)
    window.scrollTo(0, 0);
}
function $d43825b7d483c6e2$export$baddd0131ee8c05b(routes) {
    return function() {
        window.addEventListener("popstate", ()=>{
            $d43825b7d483c6e2$var$routeRender(routes);
        });
        // popstate: 브라우저의 세션 히스토리가 변경될 때 발생
        $d43825b7d483c6e2$var$routeRender(routes);
    };
}
class $d43825b7d483c6e2$export$390f32400eaf98c9 {
    constructor(state){
        console.log("state: " + state);
        console.log("this.state: " + this.state);
        // alert(this.state)
        this.state = {};
        this.observers = {};
        for(const key in state)// 어떤 오브젝트의 속성 정의
        // Object.defineProperty(obj, prop, descriptor)
        // definedProperty works as a detector for the object's property
        Object.defineProperty(this.state, key, {
            get: ()=>{
                return state[key];
            },
            // message 값이 변경되면 setter 함수가 실행됨
            set: (val)=>{
                console.log("val: " + val);
                state[key] = val;
                // alert(this.ob[key])
                // this.observers[key]();
                if (!this.observers[key]) this.observers[key] = []; // 배열로 초기화
                console.log("this.observers[key]: " + this.observers[key]);
                this.observers[key].forEach((observer)=>{
                    console.log("observer: " + observer);
                    return observer(val);
                });
            } // 속성의 값을 설정
        });
    }
    // 내용을 지속 추가할 수 있도록 옵저버 정의
    subscribe(key, cb) {
        // 여러 함수를 적용할 수 있도록 함
        // {[cb1, cb2, cb3, ...]}
        Array.isArray(this.observers[key]) ? this.observers[key].push(cb) : this.observers[key] = [
            cb
        ];
    // observers[key]가 배열이면 cb를 push
    // observers[key]가 배열이 아니면 배열로 만들고 cb를 push
    // observers[key]에 cb를 할당
    // this.observers[key] = cb
    }
}



class $3df07944bfa6aab3$export$8b251419efc915eb extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    constructor(){
        super({
            tagName: "header",
            state: {
                menus: [
                    {
                        name: "Search",
                        href: "#/"
                    },
                    {
                        name: "Random",
                        href: "#/movie?id=tt4520988"
                    },
                    {
                        name: "\uFE56",
                        href: "#/about"
                    }
                ]
            }
        });
        window.addEventListener("popstate", ()=>{
            this.render();
        });
    }
    render() {
        this.el.classList.add("header");
        this.el.innerHTML = /* html  */ `
      <div class="container flex     mx-auto px-4 py-2 
">
      <a href="#/" class="mr-auto">\u{1F37F}</a>
      <nav>
        <ul>
        ${this.state.menus.map((menu)=>{
            const href = menu.href.split("?")[0];
            const hash = location.hash.split("?")[0];
            const isActive = href === hash;
            return /* html */ `
            <li>
              <a 
                class="${isActive ? "active" : ""}"
                href="${menu.href}">${menu.name}</a>
            </li>
          `;
        }).join("")}
        </ul>
      </nav> 
      <a href="#/user" class="ml-auto nav-user">User</a> 
      </div>
    `;
    }
}




var $d99f9429fc0e2ba8$export$2e2bcd8739ae039 = new (0, $d43825b7d483c6e2$export$390f32400eaf98c9)({
    photo: "https://via.placeholder.com/150",
    name: "John Doe",
    email: "johndoe@gmail.com",
    web: "https://johndoe.com"
});


class $d5c7001fb908dd0e$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    constructor(){
        super({
            tagName: "footer"
        });
    }
    render() {
        const { name: name, web: web } = (0, $d99f9429fc0e2ba8$export$2e2bcd8739ae039).state;
        // alert(name)
        this.el.classList.add("w-full");
        this.el.innerHTML = /* html */ `
      <div class="container mx-auto p-4">
       <p>${name}</p>
        <a href="${web}">Web</a>
        <div class="mt-4 text-gray-400 text-xs">
          <span>\u{24D2} siimplelab </span><span>${new Date().getFullYear()}</span>
        </div>
        
      </div>
    `;
    }
}


class $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    render() {
        const header = new (0, $3df07944bfa6aab3$export$8b251419efc915eb)().el;
        const footer = new (0, $d5c7001fb908dd0e$export$2e2bcd8739ae039)().el;
        const routerView = document.createElement("router-view");
        this.el.append(header, routerView, footer);
    }
}





class $3463ebd5beda56d4$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    render() {
        this.el.classList.add("headline");
        this.el.innerHTML = /* html */ `
      <h1>
        OMDB API
      </h1>
      <p>
        This is a headline component.
      </p>
    `;
    }
}




const $6e34c804fb642132$var$store = new (0, $d43825b7d483c6e2$export$390f32400eaf98c9)({
    searchText: "",
    page: 1,
    pageMax: 1,
    movies: [],
    movie: {},
    loading: false,
    message: "Search for the movie title"
});
var $6e34c804fb642132$export$2e2bcd8739ae039 = $6e34c804fb642132$var$store;
const $6e34c804fb642132$export$b0c4d3ac9887d994 = async (page)=>{
    // 써치 실행 시 바로 로딩 표현
    $6e34c804fb642132$var$store.state.loading = true;
    $6e34c804fb642132$var$store.state.page = page;
    // page가 1일 때는 영화 배열 초기화
    if (page === 1) {
        // store.state.page = 1;
        $6e34c804fb642132$var$store.state.movies = [];
        $6e34c804fb642132$var$store.state.message = "";
    }
    // store.state.movies = [
    //   ...store.state.movies,
    //   ...Search
    // ]
    // console.log('Search: ', Search);
    // console.log(json);
    try {
        // const res = await fetch(`https://omdbapi.com/?apikey=key&s=${store.state.searchText}&page=${page}`)
        const res = await fetch("/api/movie", {
            method: "POST",
            body: JSON.stringify({
                title: $6e34c804fb642132$var$store.state.searchText,
                page: page
            })
        });
        // fetch는 비동기 처리
        // const json = res.json(); // 서버에서 받은 정보 분석
        // API가 Search, totalResults, Response 등의 키를 가지고 있음
        const { Search: Search, totalResults: totalResults, Response: Response, Error: Error } = await res.json(); // 비동기 처리
        // let resJson = await.res.json();
        // let Search = resJson.Search();
        if (Response === "True") {
            $6e34c804fb642132$var$store.state.movies = [
                ...$6e34c804fb642132$var$store.state.movies,
                ...Search
            ];
            $6e34c804fb642132$var$store.state.pageMax = Math.ceil(Number(totalResults) / 10);
        } else $6e34c804fb642132$var$store.state.message = Error;
    } catch (error) {
        // 상태 초기화 코드
        $6e34c804fb642132$var$store.state.pageMax = 1;
        // 에러 표출 코드
        console.log("searchMovies error: ", error);
    } finally{
        $6e34c804fb642132$var$store.state.loading = false;
    // 모든 처리 후 로딩 false로 변경
    }
    console.log("store.state.movies: " + $6e34c804fb642132$var$store.state.movies);
};
const $6e34c804fb642132$export$e7daf9f9f7371f9a = async (id)=>{
    try {
        // const res = await fetch(`https://omdbapi.com/?apikey=key&i=${id}`)
        const res = await fetch("/api/movie", {
            method: "POST",
            body: JSON.stringify({
                id: id
            })
        });
        $6e34c804fb642132$var$store.state.movie = await res.json();
    } catch (error) {
        console.log("getMovieDetails error: ", error);
    }
};


class $273a9624a2304ab6$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    render() {
        this.el.classList.add("search");
        this.el.innerHTML = /* html */ `
      <input value="${(0, $6e34c804fb642132$export$2e2bcd8739ae039).state.searchText}"placeholder="Enter the keywords to search" />
      <button class="btn btn-primary">Search</button>

    `;
        const inputEl = this.el.querySelector("input");
        inputEl.addEventListener("input", (event)=>{
            (0, $6e34c804fb642132$export$2e2bcd8739ae039).state.searchText = inputEl.value;
        });
        inputEl.addEventListener("keydown", (event)=>{
            if (event.key === "Enter" && (0, $6e34c804fb642132$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6e34c804fb642132$export$b0c4d3ac9887d994)(1);
        });
        const btnEl = this.el.querySelector(".btn");
        btnEl.addEventListener("click", (event)=>{
            if ((0, $6e34c804fb642132$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6e34c804fb642132$export$b0c4d3ac9887d994)(1);
        });
    }
}





class $16b1f0d20ff4c553$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    constructor(props){
        // 부모가 자식에게 값 넘겨줄 때의 props
        super({
            props: props,
            tagName: "a"
        });
    }
    render() {
        const { movie: movie } = this.props;
        // 영화 정보 하나를 movie에 할당
        this.el.setAttribute("href", `#/movie?id=${movie.imdbID}`);
        this.el.classList.add("movie");
        this.el.style.backgroundImage = `url(${movie.Poster})`;
        this.el.innerHTML = /* html */ `
      <div class="info">
        <strong>${movie.Title}</strong>
        <span>${movie.Year}</span>
      </div>
    `;
    }
}


class $0ea5ecacb5b82df7$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    constructor(){
        super();
        // 변화가 생기면 콜백 실행
        (0, $6e34c804fb642132$export$2e2bcd8739ae039).subscribe("movies", ()=>{
            this.render();
        });
        (0, $6e34c804fb642132$export$2e2bcd8739ae039).subscribe("loading", ()=>{
            this.render();
        });
        (0, $6e34c804fb642132$export$2e2bcd8739ae039).subscribe("message", ()=>{
            this.render();
        });
    }
    render() {
        this.el.classList.add("movie-list");
        this.el.innerHTML = /* html */ `
      ${(0, $6e34c804fb642132$export$2e2bcd8739ae039).state.message ? `<div class="message">${(0, $6e34c804fb642132$export$2e2bcd8739ae039).state.message}</div>` : '<div class="movies"></div>'}
      <div class="loading hide"></div>
    `;
        const moviesEl = this.el.querySelector(".movies");
        // movieEl이 존재할 때만 실행
        moviesEl?.append(...(0, $6e34c804fb642132$export$2e2bcd8739ae039).state.movies.map((movie)=>{
            // return movie.Title
            return new (0, $16b1f0d20ff4c553$export$2e2bcd8739ae039)({
                movie: // movie: movie // movieItem에 movie를 넘겨줌, 콜론 생략 가능
                movie
            }).el;
        }) // 새로운 배열 반환
        );
        // 전개연산자 없이 사용
        // movieStore.state.movies.map(movie => {
        //   let movieItem = new MovieItem({
        //     movie
        //   });
        //   moviesEl.append(movieItem.el);
        // });
        // 로딩
        const loadingEl = this.el.querySelector(".loading");
        (0, $6e34c804fb642132$export$2e2bcd8739ae039).state.loading ? loadingEl.classList.remove("hide") : loadingEl.classList.add("hide");
    }
}




class $65dd1421359630e2$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    constructor(){
        super({
            tagName: "button"
        });
        (0, $6e34c804fb642132$export$2e2bcd8739ae039).subscribe("pageMax", ()=>{
            // movieStore.state.page
            // movieStore.state.pageMax
            const { page: page, pageMax: pageMax } = (0, $6e34c804fb642132$export$2e2bcd8739ae039).state;
            pageMax > page ? this.el.classList.remove("hide") : this.el.classList.add("hide");
        // if (pageMax > page) {
        //   this.el.classList.remove('hide')
        // } else {
        //   this.el.classList.add('hide')
        // }
        });
    }
    render() {
        this.el.classList.add("btn", "btn-primary", "movie-list-more", "hide");
        this.el.textContent = "More";
        this.el.addEventListener("click", async (event)=>{
            this.el.classList.add("hide");
            await (0, $6e34c804fb642132$export$b0c4d3ac9887d994)((0, $6e34c804fb642132$export$2e2bcd8739ae039).state.page + 1);
        });
    }
}


class $d2f1a655c6f71850$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    render() {
        const headline = new (0, $3463ebd5beda56d4$export$2e2bcd8739ae039)().el;
        const search = new (0, $273a9624a2304ab6$export$2e2bcd8739ae039)().el;
        const movieList = new (0, $0ea5ecacb5b82df7$export$2e2bcd8739ae039)().el;
        const movieListMore = new (0, $65dd1421359630e2$export$2e2bcd8739ae039)().el;
        this.el.classList.add("container", "mx-auto", "px-4", "py-4");
        this.el.append(headline, search, movieList, movieListMore);
    }
}




class $3dc4becb2b5793f6$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    async render() {
        // 초기 SKELETON
        this.el.classList.add("container", "the-movie");
        this.el.innerHTML = /* html */ `
      <div class="poster skeleton">a</div>
      <div class="specs">
        <div class="title skeleton">b</div>
        <div class="labels skeleton">c</div>
        <div class="plot skeleton">d</div>
      </div>
    `;
        // history.state.id는 내장객체
        await (0, $6e34c804fb642132$export$e7daf9f9f7371f9a)(history.state.id);
        // 비동기로 선언한 함수이기에 await 키워드 붙임
        // 히스토리에서 ID 값 가져오기
        console.log("movieStore.state.movie: ", (0, $6e34c804fb642132$export$2e2bcd8739ae039).state.movie);
        const { movie: movie } = (0, $6e34c804fb642132$export$2e2bcd8739ae039).state;
        const bigPoster = movie.Poster.replace("SX300", "SX500");
        // replace 메서드로 이미지 사이즈 변경
        // What does replace() do in JavaScript?
        // The replace() method searches a string for a specified value, or a regular expression, and returns a new string where the specified values are replaced.
        this.el.classList.add("container", "the-movie");
        this.el.innerHTML = /* html */ `
      <div style="background-image: url(${bigPoster});" class="movie-image"></div>
      <div>
      ${movie.Title}</div>
      <div class="labels">
        <span>${movie.Year}</span>
        &nbsp;/&nbsp;
        <span>${movie.Runtime}</span>
        &nbsp;/&nbsp;
        <span>${movie.Country}</span>
      </div>
      <div class="plot">
      ${movie.Plot.full}</div>
      <div>
        <h3>Rating</h3>
        ${movie.Ratings.map((rating)=>{
            return `<p>${rating.Source} - ${rating.Value}</p>`;
        }).join("")}
      </div>
      <div>
        <h3>Actor</h3>
        <p>${movie.Actor}</p>
      </div>
      <div>
        <h3>Director</h3>
        <p>${movie.Director}</p>
      </div>
      <div>
        <h3>Writer</h3>
        <p>${movie.Writer}</p>
      </div>

      <div>
        <h3>Production</h3>
        <p>${movie.Production}</p>
      </div>

    `;
    }
}




class $3eddd9b301fef5e1$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    render() {
        const { name: name, web: web, email: email, photo: photo } = (0, $d99f9429fc0e2ba8$export$2e2bcd8739ae039).state;
        this.el.classList.add("container", "about");
        this.el.innerHTML = /* html */ `
    <img src="${photo}" alt="${name}">
      <h1>About</h1>
      <p>
        This is a SPA (Single Page Application) project.
      </p>
    `;
    }
}



class $80c3990634ad0435$export$2e2bcd8739ae039 extends (0, $d43825b7d483c6e2$export$1e8bdf0a3b60829f) {
    render() {
        // alert('Not Found Page'); 
        this.el.classList.add("container", "not-found");
        this.el.innerHTML = /* html */ `
      <h1>404</h1>
    `;
    }
}


var $bbf93c82d4cb8562$export$2e2bcd8739ae039 = (0, $d43825b7d483c6e2$export$baddd0131ee8c05b)([
    {
        path: "#/",
        test: "test",
        component: (0, $d2f1a655c6f71850$export$2e2bcd8739ae039)
    },
    {
        path: "#/movie",
        component: (0, $3dc4becb2b5793f6$export$2e2bcd8739ae039)
    },
    {
        path: "#/about",
        component: (0, $3eddd9b301fef5e1$export$2e2bcd8739ae039)
    },
    // { path: '#/404', component: NotFound }
    // { path: '.{0,}', component: NotFound } 
    {
        path: ".*",
        component: (0, $80c3990634ad0435$export$2e2bcd8739ae039)
    }
]);


const $2b6e161c9edcf319$var$root = document.querySelector("#root");
$2b6e161c9edcf319$var$root.append(new (0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039)().el);
(0, $bbf93c82d4cb8562$export$2e2bcd8739ae039)();
(async ()=>{
    const res = await fetch("/api/test");
    const json = await res.json();
    console.log("api/test :", json);
})();


//# sourceMappingURL=index.db9380dc.js.map
